import React, { useEffect, useState } from 'react';
import { ActionOptions, ThemeConfigKeys } from '../../../utils/Constants';
import { CloseSquareOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import { ThemeProvider } from '../../ThemeProvider';
import Space from 'antd/lib/space';
import { BDOperation, EntityType } from '../../../integrated-client';
import RestClient from '../../../integration/RestClient';
import LoadingBlock from '../../../components/LoadingBlock/LoadingBlock';
import {getFormattedDateAndTimeFromString} from '../../../utils/MiscUtils';
import styles from './HistoryModal.module.scss';
import Modal from 'antd/lib/modal/Modal';

export interface ISearchManagerHistoryModalProps {
  showHistoryModal: boolean;
  setShowHistoryModal: (val: boolean) => void;
  actionType: ActionOptions;
  id: string;
  type: EntityType;  
  handleRowSelect: (val1: any, val2: any) => void;
}

const HistoryModal: React.FC<ISearchManagerHistoryModalProps> = (props) => {
  const { showHistoryModal, setShowHistoryModal, actionType, id,  type, handleRowSelect} = props;
  const [showLoading, setShowLoading] = useState(false);
  const [historyData, setHistoryData] = useState<Array<BDOperation>>([]);
  const [errMessage, setErrMessage] = useState('')

  const handleCloseButtonClick = () => {
    closeEditorModal();
  };

  const closeEditorModal = () => {
    setShowHistoryModal(false);
    handleRowSelect([],[]);
  };

   useEffect(() => {
    setShowLoading(true);
     RestClient.historyV2.updateHistoryV2HistoryGet({id, type})
      .then((data: Array<BDOperation>) => {
        setShowLoading(false);
        setHistoryData(data);
      })
      .catch(() => {
        setShowLoading(false)
        setErrMessage('There is no history for this item')
      })
  }, [])

  const renderSubRuleModalWindowHeader = (): React.ReactNode => (
    <div className={styles.headerContainer}>
      <div className={styles.headerFirstLine}>
        <div className={styles.headerMainText}>
          {settings?.title}
        </div>
        <div className={styles.headerButtons}>
          <Space>
            <Space size={5}>
              <ThemeProvider themeKey={ThemeConfigKeys.DnataBlueCloseBtn}>
                <Button onClick={handleCloseButtonClick} className={styles.closeButton} type="primary">
                  <CloseSquareOutlined />
                </Button>
              </ThemeProvider>
            </Space>
          </Space>
        </div>
      </div>
    </div>
  );

  enum titleNames {
    History = 'HISTORY',
  }

  interface IModalWindowSetting {
    title: string;
    layout?: any;
    width?: number;
    addDisabledCheck?: boolean;
  }

  interface IModalWindowSettings {
    [ActionOptions.History]: IModalWindowSetting;
  }

  const modalWindowSettings: IModalWindowSettings = {
    [ActionOptions.History]: {
      title: titleNames.History,
      addDisabledCheck: true,
      width: 600,
    },
  };

  const settings = actionType && modalWindowSettings[actionType as ActionOptions.History];

  const NewlineText = (text: string) => {
    return <div className={styles.historyUpdateItem}>
      {
        text?.split('\n')
          .map(str => <>{str}<br /></>)
      }
    </div>;
  }

  return (
    <>
      <Modal
        open={showHistoryModal}
        title={renderSubRuleModalWindowHeader()}
        className={styles.historyModal}
        footer={null}
        closable={false}
        centered
        destroyOnClose
        width={settings?.width}
        bodyStyle={{height: 350, overflowY: 'auto'}}
      >
      {showLoading && <LoadingBlock/>}
      {!showLoading && errMessage === '' && historyData.length && historyData.map((data: any) => {
      return <>
        <div className={styles.row}>
          <span className={styles.actionLine}>
            <span className={styles.updatedBy}>{data.updatedBy} </span>
            {data.action} - {getFormattedDateAndTimeFromString(data.updatedDate)}
          </span>
          {data.updates?.length ?
            <div className={styles.historyUpdateItemsWrapper}>
              <div className={styles.historyUpdateItemCaptions}>
                <div className={styles.historyUpdateItemCaption}><strong>Field</strong></div>
                <div className={styles.historyUpdateItemCaption}><strong>Original Value</strong></div>
                <div className={styles.historyUpdateItemCaption}><strong>New Value</strong></div>
              </div>
              {data.updates.map((update:any) => {
                return <div className={styles.historyUpdateItems}>
                  <div className={styles.historyUpdateItem}>{update.name}</div>
                  {NewlineText(update.oldValue!)}
                  {NewlineText(update.newValue!)}
                </div>
              })
              }
            </div>
            : null
          }
        </div>
      </>
      })
      }
      {errMessage !== '' &&
      <div>
      {errMessage}
      </div>}
      </Modal>
    </>
  );
};

export default HistoryModal;
